export const ALERT_MODAL_CONTENT_BACKGROUND_COLOR = '#F9F9F9';
